import { Outlet, Route } from "react-router-dom"
import { pagesUrl } from "../core/appConstants"
import { BSModelContextProvider } from "../core/context/beem-shot/BSBimModel/BSBimModelContext"
import { BSModelFileContextProvider } from "../core/context/beem-shot/BSBimModel/BSBimModelFileContext"
import { BSBuildingResultContextProvider } from "../core/context/beem-shot/BSBuildingResult/BSBuildingResultContext"
import { BSCategoriesContextProvider } from "../core/context/beem-shot/BSCategory/BSCategoriesContext"
import { BSCodesExtraitsContextProvider } from "../core/context/beem-shot/BSCodeExtrait/BSCodesExtraitsContext"
import { BSInputContextProvider } from "../core/context/beem-shot/BSInput/BSInputContext"
import { BSItemContextProvider } from "../core/context/beem-shot/BSItems/BSItemContext"
import { BSMaterialContextProvider } from "../core/context/beem-shot/BSMaterialResult/BSMaterialResultContext"
import IniesRecordContextProvider from "../core/context/IniesContext"
import { LotContextProvider } from "../core/context/lot-context"
import MaterialLibContextProvider from "../core/context/material/material-lib-context"
import MaterialLibDeclarationTypeContextProvider from "../core/context/material/material-lib-declaration-type-context"
import { MaterialLibFilterContextProvider } from "../core/context/material/material-lib-filter-context"
import MaterialLibSearchContextProvider from "../core/context/material/material-lib-search-context"
import DomainNameValidatorContextProvider from "../core/context/organization/domain-name-validator-context"
import { BSVariantDetailsPage } from "../pages/projects/project/beem-shot/variant/BSVariantDetailsPage"
import { BSCalculationPage } from "../pages/projects/project/beem-shot/variant/building/BSCalculationPage/BSCalculationPage"
import { BSBuildingChoicePage } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBimModelChoicePage/BSBuildingChoicePage"
import { BSBimModelChoice } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBimModelChoicePage/components/BSBimModelChoicePage"
import { BSBuildingFondationPage } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingFondationPage/BSBuildingFondationPage"
import { BSParkingPage } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingParkingPage/BSParkingPage"
import { BSParkingContextProvider } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingParkingPage/context/BSParkingContext"
import { BSParkingListContextProvider } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSBuildingParkingPage/context/BSParkingListContext"
import { BSPatioPage } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSPatioPage/BSPatioPage"
import { BSPatioContextProvider } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSPatioPage/context/BSPatioContext"
import { BSZoneAndLevelPage } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSZoneAndLevelPage/BSZoneAndLevelPage"
import { BSLevelContextProvider } from "../pages/projects/project/beem-shot/variant/building/BSCreateBuildingPages/BSZoneAndLevelPage/context/BSLevelContext"
import { BSBuildingMorphologyContextProvider } from "../pages/projects/project/beem-shot/variant/tabs/BSBuildingTabs/BSBuildingMorphologyTab/context/BSBuildingMorphologyContext"
import { BSCustomizationPage } from "../pages/projects/project/beem-shot/variant/tabs/BSBuildingTabs/BSCustomizationTab/BSCustomizationPage"
import { SelectionContextProvider } from "../pages/projects/project/beem-shot/variant/tabs/BSBuildingTabs/BSCustomizationTab/components/context/SelectionContext"
import { BSConfirmResetAllDialogContextProvider } from "../pages/projects/project/beem-shot/variant/tabs/BSBuildingTabs/BSCustomizationTab/components/dialog/BSCustomResetAllDialog/BSConfirmResetAllDialogContext"

export const BSRoutes = (
  <Route element={<Outlet />}>
    {/* Beem Shot main pages */}
    <Route
      element={
        <BSBuildingResultContextProvider>
          <BSBuildingMorphologyContextProvider>
            <BSParkingListContextProvider>
              <BSParkingContextProvider>
                <BSLevelContextProvider>
                  <BSPatioContextProvider>
                    <BSInputContextProvider>
                      <LotContextProvider>
                        <DomainNameValidatorContextProvider>
                          <BSCategoriesContextProvider>
                            <BSModelContextProvider>
                              <BSModelFileContextProvider>
                                <BSItemContextProvider>
                                  <BSCodesExtraitsContextProvider>
                                    <Outlet />
                                  </BSCodesExtraitsContextProvider>
                                </BSItemContextProvider>
                              </BSModelFileContextProvider>
                            </BSModelContextProvider>
                          </BSCategoriesContextProvider>
                        </DomainNameValidatorContextProvider>
                      </LotContextProvider>
                    </BSInputContextProvider>
                  </BSPatioContextProvider>
                </BSLevelContextProvider>
              </BSParkingContextProvider>
            </BSParkingListContextProvider>
          </BSBuildingMorphologyContextProvider>
        </BSBuildingResultContextProvider>
      }>
      <Route path={pagesUrl.VARIANT_DETAILS} element={<BSVariantDetailsPage />} />

      <Route path={pagesUrl.BUILDING_CHOICE} element={<BSBuildingChoicePage />} />
      <Route path={pagesUrl.BUILDING_ZONE_AND_LEVEL} element={<BSZoneAndLevelPage />} />
      <Route path={pagesUrl.BUILDING_FONDATION} element={<BSBuildingFondationPage />} />
      <Route path={pagesUrl.BUILDING_PARKING} element={<BSParkingPage />} />
      <Route path={pagesUrl.BUILDING_PATIO} element={<BSPatioPage />} />

      {/*<Route path={pagesUrl.BEEM_SHOT_BIM_MODEL_DETAIL_PAGE} element={<BSBimModelDetailPage />} />*/}
      <Route path={pagesUrl.BEEM_SHOT_BIM_MODEL_CHOICE} element={<BSBimModelChoice />} />
      <Route path={pagesUrl.CALCUL} element={<BSCalculationPage isBeemShot />} />
      <Route path={pagesUrl.CALCUL_MORPHOLOGY} element={<BSCalculationPage isBeemMorphology />} />
      <Route
        path={pagesUrl.BEEM_SHOT_CUSTOM_MATERIALS}
        element={
          <SelectionContextProvider>
            <BSMaterialContextProvider>
              <MaterialLibFilterContextProvider>
                <MaterialLibSearchContextProvider>
                  <MaterialLibContextProvider>
                    <MaterialLibDeclarationTypeContextProvider>
                      <IniesRecordContextProvider>
                        <BSConfirmResetAllDialogContextProvider>
                          <MaterialLibFilterContextProvider>
                            <BSCustomizationPage />
                          </MaterialLibFilterContextProvider>
                        </BSConfirmResetAllDialogContextProvider>
                      </IniesRecordContextProvider>
                    </MaterialLibDeclarationTypeContextProvider>
                  </MaterialLibContextProvider>
                </MaterialLibSearchContextProvider>
              </MaterialLibFilterContextProvider>
            </BSMaterialContextProvider>
          </SelectionContextProvider>
        }
      />
    </Route>
  </Route>
)
